import logger from "./utils/logger";
import { captureException } from "./utils/sentryBridge";

/**
 * Registers global handlers for uncaught exceptions and unhandled promise rejections
 * that escape React's error boundary. Logs via the shared logger and reports to
 * Sentry when available.
 *
 * @returns {function(): void} Unregister function to remove the listeners
 */
export function registerGlobalErrorHandlers() {
    if (typeof window === "undefined") {
        return () => {};
    }

    const handleError = event => {
        const errorObj = event.error || new Error(event.message);
        logger.error(errorObj, {
            type: "window.onerror",
            message: event.message,
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
        });
        captureException(errorObj, {
            type: "window.onerror",
            message: event.message,
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
        });
    };

    const handleUnhandledRejection = event => {
        logger.error(event.reason, { type: "unhandledrejection" });
        captureException(event.reason, { type: "unhandledrejection" });
        event.preventDefault();
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
        window.removeEventListener("error", handleError);
        window.removeEventListener("unhandledrejection", handleUnhandledRejection);
    };
}
